import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lik-opo-lik',
  templateUrl: './lik-opo-lik.component.html',
  styleUrls: ['./lik-opo-lik.component.scss']
})
export class LikOpoLikComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
